import MetaDataModel from '../models/MetaDataModel';
import BaseStore from './BaseStore';

class MetaDataStore extends BaseStore {
  constructor(transportLayer) {
    super(MetaDataModel, transportLayer);
  }
}

export default MetaDataStore;



// WEBPACK FOOTER //
// ./src/stores/MetaDataStore.js